// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.email,\n.el-table td.email {\n  width: 25em;\n}", ""]);
// Exports
module.exports = exports;
